import { render, staticRenderFns } from "./SubAdminTop.vue?vue&type=template&id=76ca2d3d&"
import script from "./SubAdminTop.vue?vue&type=script&lang=js&"
export * from "./SubAdminTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports